/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportCostsByLocation
 */
export interface ReportCostsByLocation {
    /**
     * 
     * @type {string}
     * @memberof ReportCostsByLocation
     */
    locationName: string;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByLocation
     */
    locationId: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByLocation
     */
    employees: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportCostsByLocation
     */
    employeeIds: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByLocation
     */
    shifts: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByLocation
     */
    hoursScheduled: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByLocation
     */
    hoursWorked: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByLocation
     */
    costsScheduled: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByLocation
     */
    costsWorked: number | null;
}

/**
 * Check if a given object implements the ReportCostsByLocation interface.
 */
export function instanceOfReportCostsByLocation(value: object): value is ReportCostsByLocation {
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('employees' in value) || value['employees'] === undefined) return false;
    if (!('employeeIds' in value) || value['employeeIds'] === undefined) return false;
    if (!('shifts' in value) || value['shifts'] === undefined) return false;
    if (!('hoursScheduled' in value) || value['hoursScheduled'] === undefined) return false;
    if (!('hoursWorked' in value) || value['hoursWorked'] === undefined) return false;
    if (!('costsScheduled' in value) || value['costsScheduled'] === undefined) return false;
    if (!('costsWorked' in value) || value['costsWorked'] === undefined) return false;
    return true;
}

export function ReportCostsByLocationFromJSON(json: any): ReportCostsByLocation {
    return ReportCostsByLocationFromJSONTyped(json, false);
}

export function ReportCostsByLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportCostsByLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'locationName': json['locationName'],
        'locationId': json['locationId'],
        'employees': json['employees'],
        'employeeIds': json['employeeIds'],
        'shifts': json['shifts'],
        'hoursScheduled': json['hoursScheduled'],
        'hoursWorked': json['hoursWorked'],
        'costsScheduled': json['costsScheduled'],
        'costsWorked': json['costsWorked'],
    };
}

  export function ReportCostsByLocationToJSON(json: any): ReportCostsByLocation {
      return ReportCostsByLocationToJSONTyped(json, false);
  }

  export function ReportCostsByLocationToJSONTyped(value?: ReportCostsByLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationName': value['locationName'],
        'locationId': value['locationId'],
        'employees': value['employees'],
        'employeeIds': value['employeeIds'],
        'shifts': value['shifts'],
        'hoursScheduled': value['hoursScheduled'],
        'hoursWorked': value['hoursWorked'],
        'costsScheduled': value['costsScheduled'],
        'costsWorked': value['costsWorked'],
    };
}

